import { camelCase, merge } from "lodash";
import React from "react";
import LiveGuidanceDetails from "../guidance/LiveGuidanceDetails";
import LiveGuidanceMyRecentSales from "../guidance/LiveGuidanceMyRecentSales";
import IconActionPlan from "../icons/IconActionPlan";
import IconAgent from "../icons/IconAgent";
import IconContract from "../icons/IconContract";
import IconCustomPage from "../icons/IconCustomPage";
import IconDistribution from "../icons/IconDistribution";
import IconIntelligentPricing from "../icons/IconIntelligentPricing";
import IconLightBulb from "../icons/IconLightBulb";
import IconMyRecentSales from "../icons/IconMyRecentSales";
import IconOurCompany from "../icons/IconOurCompany";
import IconTextMessage from "../icons/IconTextMessage";
import IconWhatIsACMA from "../icons/IconWhatIsACMA";
import LivePreviewAboutMe from "../previews/LivePreviewAboutMe";
import LivePreviewClientTestimonials from "../previews/LivePreviewClientTestimonials";
import LivePreviewCommissionDistribution from "../previews/LivePreviewCommissionDistribution";
import LivePreviewCustomPage from "../previews/LivePreviewCustomPage";
import LivePreviewIntelligentPricing from "../previews/LivePreviewIntelligentPricing";
import LivePreviewListingAgreement from "../previews/LivePreviewListingAgreement";
import LivePreviewMarketingActionPlan from "../previews/LivePreviewMarketingActionPlan";
import LivePreviewMultipleListingServiceBuyer from "../previews/LivePreviewMultipleListingServiceBuyer";
import LivePreviewMultipleListingServiceSeller from "../previews/LivePreviewMultipleListingServiceSeller";
import LivePreviewMyRecentSales from "../previews/LivePreviewMyRecentSales";
import LivePreviewOurCompany from "../previews/LivePreviewOurCompany";
import LivePreviewPDFPage from "../previews/LivePreviewPDFPage";
import LivePreviewWhatIsACMA from "../previews/LivePreviewWhatIsACMA";

export const createModules = ({ guid, modules, links = {} }) => {
  const modifiedLinks = getModifiedLinks(modules, links);
  const newModules = modules
    .filter((module) => module.key !== "cover_letter")
    .map((module) => {
      const transformedModule = transformModule(module, guid);
      const camelCaseKey = camelCase(transformedModule.key);
      const linkData = modifiedLinks[camelCaseKey] || {};
      const { key, ...linkDataWithoutKey } = linkData;
      return { ...transformedModule, ...linkDataWithoutKey };
    });
  return newModules;
};

export function transformModule(data, guid) {
  return {
    key: data.key,
    title: data.title,
    footerTitle: data.title,
    url: data.isCustom
      ? `/live/${guid}/custom/${data.key}`
      : `/live/${guid}/${data.key}`,
    path: data.isCustom
      ? `/live/:guid/custom/${data.key}`
      : `/live/:guid/${data.key}`,
    isHidden: false,
    canHide: true,
    el: getElement(data),
    previewEl: getPreviewElement(data),
    iconEl: getIconElement(data),
    showSparkle: !!data.showSparkle,
    subModules: [],
    data
  };
}

// Only a stub for now
export function transformSubModule(data) {
  return data;
}

function getModifiedLinks(data, links) {
  const newLinks = data.reduce((byKey, page) => {
    const camelCaseKey = camelCase(page.key);
    const isHidden = page.isHidden;
    return {
      ...byKey,
      [camelCaseKey]: {
        isHidden:
          // If we don't have links for the page, hide if content is blank
          // else hide or show based on what the user has selected.
          typeof links[camelCaseKey] === "undefined"
            ? isHidden
            : links[camelCaseKey].isHidden
      }
    };
  }, {});
  return merge({}, links, newLinks);
}

function getElement(page) {
  switch (page.key) {
    case "my-recent-sales":
      return <LiveGuidanceMyRecentSales pageKey={page.key} />;
    default:
      return <LiveGuidanceDetails pageKey={page.key} />;
  }
}

function getPreviewElement(page) {
  const key = page.isPdf ? "pdf" : page.key;
  switch (key) {
    case "agent-resume":
      return <LivePreviewAboutMe title={page.title} />;
    case "my-recent-sales":
      return <LivePreviewMyRecentSales title={page.title} />;
    case "our-company":
      return <LivePreviewOurCompany title={page.title} />;
    case "what-is-a-cma":
      return <LivePreviewWhatIsACMA title={page.title} />;
    case "marketing-action-plan":
      return <LivePreviewMarketingActionPlan title={page.title} />;
    case "money-distribution":
      return <LivePreviewCommissionDistribution title={page.title} />;
    case "importance-of-intelligent-pricing":
      return <LivePreviewIntelligentPricing title={page.title} />;
    case "client-testimonials":
      return <LivePreviewClientTestimonials title={page.title} />;
    case "listing-paperwork-overview":
      return <LivePreviewListingAgreement title={page.title} />;
    case "pdf":
      return <LivePreviewPDFPage title={page.title} />;
    case "multiple-listing-service-seller":
      return <LivePreviewMultipleListingServiceSeller title={page.title} />;
    case "multiple-listing-service-buyer":
      return <LivePreviewMultipleListingServiceBuyer title={page.title} />;
    default:
      return <LivePreviewCustomPage title={page.title} />;
  }
}

function getIconElement(page) {
  switch (page.key) {
    case "agent-resume":
      return <IconAgent />;
    case "my-recent-sales":
      return <IconMyRecentSales />;
    case "our-company":
      return <IconOurCompany />;
    case "what-is-a-cma":
      return <IconWhatIsACMA />;
    case "marketing-action-plan":
      return <IconActionPlan />;
    case "money-distribution":
      return <IconDistribution />;
    case "importance-of-intelligent-pricing":
      return <IconIntelligentPricing />;
    case "client-testimonials":
      return <IconTextMessage />;
    case "listing-paperwork-overview":
      return <IconContract />;
    case "multiple-listing-service-seller":
      return <IconLightBulb />;
    case "multiple-listing-service-buyer":
      return <IconLightBulb />;
    default:
      return <IconCustomPage />;
  }
}
